import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { grupoProducto } from '../grupoProducto';

import { GrupoProductoService } from '../grupoProducto.service';

@Component({
  selector: 'app-grupo',
  templateUrl: './grupo.component.html',
  styleUrls: ['./grupo.component.scss']
})
export class GrupoComponent implements  OnInit {
  grupos: grupoProducto[] = [];
  gruposActualizar: grupoProducto;
  listagruposActulizar: grupoProducto[] = [];
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: grupoProducto[] = [];
  previous: any = [];
  isLoadingResults = true;
  colorSeleccionado:string;


  constructor(private alertService: AlertService,private api: GrupoProductoService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  colors = [
    { name: 'Sin color', hex: '' },
    { name: 'Azul ', hex: '#a8d5e2' },
    { name: 'Verde ', hex: '#b4e3ac' },
    { name: 'Amarillo', hex: '#fef3b7' },
    { name: 'Rosa', hex: '#f4c1c0' },
    { name: 'Púrpura', hex: '#d4a4f4' },
    { name: 'Blanco', hex: '#ffffff' } ,
    { name: 'Durazno', hex: '#ffcccb' },
    { name: 'Lavanda', hex: '#e6e6fa' },
    { name: 'Celeste', hex: '#add8e6' },
    { name: 'Menta', hex: '#b2fba5' },
    { name: 'Melocotón', hex: '#ffb3ba' },
    { name: 'Lima', hex: '#d1f0d1' },
    { name: 'Salmón', hex: '#ffabab' },
    { name: 'Lavanda Claro', hex: '#f3e5f5' },
    { name: 'Beige', hex: '#f5f5dc' },
    { name: 'Gris Claro', hex: '#d3d3d3' }
  ];


  mensaje(unid: grupoProducto) {



        this.editForm.controls.descripcion.setValue(unid.tipo);
        this.editForm.controls.color.setValue(unid.color);
        this.editForm.controls.id.setValue(unid.id);
        
    this.mdbModal.show();

  }


listar(){

  this.api.getGrupo(localStorage.getItem('id'))
  .subscribe((
    data: grupoProducto[]) => {
    this.grupos = data;
    console.log(this.grupos);
    this.mdbTable.setDataSource(this.grupos);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {

    this.listar();

    this.editForm = this.formBuilder.group({
      descripcion: ['', Validators.required],
      color: ['', Validators.required],
      id: [0, Validators.required]
     
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminar(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..")
        this.listar();

      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }

  agregar(content) {
    this.editForm = this.formBuilder.group({
      id: [0],
      descripcion: ['', Validators.required],
      color: ['', Validators.required]
    });

    this.mdbModal.show();
    this.listar();
  }


  actulizar() {
    this.gruposActualizar = new grupoProducto();
    this.gruposActualizar.id=this.editForm.controls.id.value;
    this.gruposActualizar.tipo=this.editForm.controls.descripcion.value;
    this.gruposActualizar.idEmisor = Number(localStorage.getItem('id'));
    this.gruposActualizar.color=this.colorSeleccionado
    this.listagruposActulizar[0] = this.gruposActualizar;
   
    this.api.setActulizar(this.listagruposActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..")
        this.mdbModal.hide();
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  


  }
  onColorChange(event: any) {
    this.colorSeleccionado = event.target.value;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.grupos = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.grupos = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
